import type { RouteRecordRaw } from 'vue-router'

export const creditNoteRoutes: RouteRecordRaw[] = [
  {
    path: '/credit-notes',
    name: 'credit-notes',
    component: () => import('./CreditNotesWrapper.vue'),
    beforeEnter: async () => {
      const { useUserStore } = await import('src/CrudManager/Core/stores/useUserStore')
      return useUserStore().hasPermission('ar.view') || { path: '/' }
    },
    meta: {
      title: 'Notes de crédit',
      requiresAuth: true,
      roles: ['admin', 'manager', 'developer'],
    },
  },
]

export default creditNoteRoutes
